var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75261 0.335938C4.31602 0.335938 2.93826 0.90662 1.92244 1.92244C0.90662 2.93826 0.335938 4.31601 0.335938 5.7526V7.83594H33.6693V5.7526C33.6693 5.04128 33.5292 4.33692 33.257 3.67974C32.9847 3.02256 32.5858 2.42543 32.0828 1.92244C31.5798 1.41946 30.9827 1.02047 30.3255 0.748257C29.6683 0.476044 28.9639 0.335937 28.2526 0.335938H5.75261ZM33.6693 10.3359H0.335938V18.2526C0.335938 19.6892 0.90662 21.0669 1.92244 22.0828C2.93826 23.0986 4.31602 23.6693 5.75261 23.6693H28.2526C28.9639 23.6693 29.6683 23.5292 30.3255 23.257C30.9827 22.9847 31.5798 22.5858 32.0828 22.0828C32.5858 21.5798 32.9847 20.9827 33.257 20.3255C33.5292 19.6683 33.6693 18.9639 33.6693 18.2526V10.3359ZM23.2526 16.1693H27.4193C27.7508 16.1693 28.0687 16.301 28.3032 16.5354C28.5376 16.7698 28.6693 17.0877 28.6693 17.4193C28.6693 17.7508 28.5376 18.0687 28.3032 18.3032C28.0687 18.5376 27.7508 18.6693 27.4193 18.6693H23.2526C22.9211 18.6693 22.6031 18.5376 22.3687 18.3032C22.1343 18.0687 22.0026 17.7508 22.0026 17.4193C22.0026 17.0877 22.1343 16.7698 22.3687 16.5354C22.6031 16.301 22.9211 16.1693 23.2526 16.1693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLogo);
export default __webpack_public_path__ + "static/media/creditCardLogo.1352cef92df81d12149d69cc78391f38.svg";
export { ForwardRef as ReactComponent };